import { CloudProvisionerHeader } from "~/models/cloudprovisionertemplate/CloudProvisionerHeader";
import { SIMPLCloudEntity } from "../cloudtable/SimplCloudEntity";
import { useGetCloudProvisionerListWithPaginationQuery } from "~/services/cloudProvisioner";
import { useDeleteCloudEnvironmentsMutation } from "~/services/cloudenvironment";
import { DetailViewCloudProvisioner } from "./DetailsViewCloudProvisioner";


export const SIMPLCloudProvisioner = () => {
  
  return (
    <SIMPLCloudEntity
  title="Cloud Provisioner Template"
  addLabel="Add New"
  tableHeaders={CloudProvisionerHeader}
  fetchHook={useGetCloudProvisionerListWithPaginationQuery}
  deleteHook={useDeleteCloudEnvironmentsMutation}
  showButtonMoreActions={true}
  navigateAddRoute="/cloud-provisioner-template/add"
  navigateEditRoute="/cloud-provisioner-template/update"
  detailViewComponent={DetailViewCloudProvisioner}
  showButtonDecommissionInModal={false}
  showButtonDownloadInModal={false}
  showConfigFileInModal={false}
   showButtonDeleteInModal={false}
  showButtonDetailsInModal={false}
  showEditInModal={false}
/>

  );
};


